import Highcharts from 'highcharts';

export const createDefaultCreditsOptions = (
): Highcharts.CreditsOptions => ({
  enabled: false,
});
